import { Stack } from '@mui/material';

import { QUESTIONNAIRE_PAGE_BOX_SX, QuestionnaireSectionLabel } from '../../../../common';
import { FamilyFields } from '../../../../../common';
import {
  useIntakeClientSiblings,
  useIntakeFamilyAdditionalInfo,
  useIntakeFamilyCulturalConsideration,
  useIntakeFamilyMembers,
} from './hooks';
import { useIntakeQuestionnaireLoading } from '../../../hooks';
import { FORTA_BLUE } from '../../../../../../utils/colors';

export default function FamilyForm() {
  const {
    familyMembers,
    isCreating,
    isSaving: isSavingMember,
    create: createMember,
    update: updateMember,
    remove: removeMember,
  } = useIntakeFamilyMembers();
  const {
    siblings,
    isSaving: isSavingSibling,
    create: createSibling,
    update: updateSibling,
    remove: removeSibling,
  } = useIntakeClientSiblings();
  const {
    additionalInfo,
    hasSavedValues,
    isSaving: isSavingAdditionalInfo,
    create: createAdditionalInfo,
    remove: removeAdditionalInfo,
  } = useIntakeFamilyAdditionalInfo();
  const { culturalConsideration, save: saveCulturalConsideration } =
    useIntakeFamilyCulturalConsideration();
  const isLoading = useIntakeQuestionnaireLoading();

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Family background
      </QuestionnaireSectionLabel>
      <Stack textAlign="left" sx={QUESTIONNAIRE_PAGE_BOX_SX}>
        <FamilyFields
          additionalInfo={additionalInfo}
          culturalConsideration={culturalConsideration}
          disabled={isLoading}
          familyMembers={familyMembers}
          hasSavedValues={hasSavedValues}
          isSavingAdditionalInfo={isSavingAdditionalInfo}
          isSavingMember={isCreating || isSavingMember}
          isSavingSibling={isSavingSibling}
          onCreateAdditionalInfo={createAdditionalInfo}
          onCreateMember={createMember}
          onCreateSibling={createSibling}
          onDeleteAdditionalInfo={removeAdditionalInfo}
          onDeleteMember={removeMember}
          onDeleteSibling={removeSibling}
          onSaveCulturalConsideration={saveCulturalConsideration}
          onUpdateMember={updateMember}
          onUpdateSibling={updateSibling}
          showListErrors={!isLoading}
          siblings={siblings}
        />
      </Stack>
    </>
  );
}
